<template>
  <div class="hello hello-inidicator-map w-100" id="chartdivMap"></div>
</template>

<script>
/* eslint-disable */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import globalVar from "@/assets/globalVar.json"


export default {
  data() {
    return {
      SelectedInd: '',
    }
  },
  props: {
    map: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    selectedIndicator: {
      type: String,
      required: true
    }
  },
  methods: {
    getColor(value) {
      let rangesData = [];

      if (this.type == "risk") {
        rangesData = globalVar.risk
      }
      if (this.type == "opport") {
        rangesData = globalVar.opport
      }

      let category = '';
      if (value >= 5) {
        category = rangesData[4].color;
      } else {
        category = '#808080'
        for (let i = 0; i < rangesData.length; i++) {
          if (value >= rangesData[i].rangeMin - 0.005 && value <= rangesData[i].rangeMax - 0.005) {
            category = rangesData[i].color;
            break;
          }
        }
      }

      return category;
    },
    /*handleHit(ev) {
      this.$router.push('/country/' + ev.target.dataItem.dataContext.name);
    },*/
    handleHit(ev) {
      let cntname = ev.target.dataItem.dataContext.name;
      if (cntname == "Palestinian Territories") {
        cntname = "Palestine"
      }
      const url = '/country/' + cntname;
      // console.log(ev.target.dataItem.dataContext)
      window.location.href = url;
    },
    renderChart() {
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartdivMap", am4maps.MapChart);

      chart.geodata = am4geodata_worldLow;

      chart.projection = new am4maps.projections.Miller();
      chart.homeGeoPoint = {
        latitude: 30, // Keep it centered vertically
        longitude: 50 // Shift to the left horizontally, adjust this value as needed
      };
      let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

      polygonSeries.useGeodata = true;

      const mapData = Object.values(this.map).map(item => ({
        id: item.name,
        value: item.risk,
        value_str: item.risk !== null ? (Math.round(item.risk * 100) / 100).toFixed(2) : '',
        fill: am4core.color(this.getColor(item.risk)),
      }));
      polygonSeries.data = mapData;


      let polygonTemplate = polygonSeries.mapPolygons.template;
      polygonTemplate.applyOnClones = true;
      polygonTemplate.togglable = false;
      polygonTemplate.tooltipText = "{name} : {value_str}";
      polygonTemplate.nonScalingStroke = true;
      polygonTemplate.strokeOpacity = 0.5;
      polygonTemplate.fill = 'rgb(128, 128, 128)';
      polygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      polygonTemplate.events.on("hit", this.handleHit);
      polygonTemplate.fill = 'rgb(128, 128, 128)';

      polygonTemplate.propertyFields.fill = "fill";

      polygonSeries.exclude = ["AQ"];
      var legend = new am4maps.Legend();
      legend.parent = chart.chartContainer;
      legend.background.fill = am4core.color("#000");
      legend.background.fillOpacity = 0.05;
      legend.width = 275;
      legend.align = "right";
      legend.padding(10, 15, chart.chartContainer.maxHeight, 15);

      let rangesData = [];

      if (this.type == "opport") {
        rangesData = globalVar.opport
      } else {
        rangesData = globalVar.risk
      }
      legend.data = [{
        "name": `${rangesData[0].indicator} (${rangesData[0].rangeMin.toFixed(2)} to ${(rangesData[0].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[0].color
      }, {
        "name": `${rangesData[1].indicator} (${rangesData[1].rangeMin.toFixed(2)} to ${(rangesData[1].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[1].color
      }, {
        "name": `${rangesData[2].indicator} (${rangesData[2].rangeMin.toFixed(2)} to ${(rangesData[2].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[2].color
      }, {
        "name": `${rangesData[3].indicator} (${rangesData[3].rangeMin.toFixed(2)} to ${(rangesData[3].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[3].color
      }, {
        "name": `${rangesData[4].indicator} (${rangesData[4].rangeMin.toFixed(2)} to ${(rangesData[4].rangeMax).toFixed(2)})`,
        "fill": rangesData[4].color
      },
      {
        "name": "no/partial assessment \ndue to lack of data",
        "fill": "#808080"
      }];
      legend.itemContainers.template.clickable = false;
      legend.itemContainers.template.focusable = false;

      var legendTitle = legend.createChild(am4core.Label);
      legendTitle.text = "Risk level :";
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = this.$route.params.element + "Map";
      chart.exporting.menu.align = "left";
      chart.exporting.menu.verticalAlign = "top";
    }
  },
  mounted() {
    this.renderChart()
  }
}
</script>